import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import Dashboard from "./pages/Dashboard";
import History from "./pages/History";
import Settings from "./pages/Settings";
import { Sun, Moon, ReceiptText } from "lucide-react";
import { api } from "./api";
import "./index.css";

export default function App() {
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem("theme") || "light";
  });
  const [settings, setSettings] = useState(null);

  // Sync theme to document element
  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") {
      root.classList.add("dark");
    } else {
      root.classList.remove("dark");
    }
    localStorage.setItem("theme", theme);
  }, [theme]);

  // Fetch settings for default splits badge
  useEffect(() => {
    api.getSettings()
      .then((s) => setSettings(s))
      .catch(() => {});
  }, []);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  };

  // e.g. "Tenant 80/70"
  const splitLabel = settings
    ? `Tenant ${Math.round(settings.default_electricity_split * 100)}/${Math.round(
        settings.default_other_split * 100
      )}`
    : "Tenant 80/70";

  return (
    <BrowserRouter>
      <div className="flex min-h-screen">
        <Sidebar />
        
        <main className="ml-[220px] flex-1 p-10 max-w-[950px] relative z-10">
          {/* Universal Premium Top Header */}
          <header className="flex justify-between items-center mb-8 pb-5 border-b border-border transition-colors duration-300">
            <div className="flex items-center">
              <div>
                <div className="flex items-center gap-2.5 flex-wrap">
                  <h1 className="font-display text-[21px] font-extrabold text-text-primary tracking-tight leading-none">
                    Utility Bill Splitter
                  </h1>
                  <span className="bg-emerald-50 text-emerald-600 dark:bg-emerald-950/30 dark:text-emerald-400 border border-emerald-200/50 dark:border-emerald-800/30 text-[11px] font-bold px-2 py-0.5 rounded-full">
                    {splitLabel}
                  </span>
                </div>
                <p className="text-[12px] text-text-muted mt-1 font-medium">
                  Automatic charge parsing & history tracking
                </p>
              </div>
            </div>

            {/* Theme Toggle Button */}
            <button
              onClick={toggleTheme}
              aria-label="Toggle theme mode"
              className="p-2.5 rounded-xl bg-surface border border-border text-text-secondary hover:text-text-primary hover:border-text-muted transition-all active:scale-95 shadow-sm"
            >
              {theme === "dark" ? <Sun size={18} /> : <Moon size={18} />}
            </button>
          </header>

          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/history" element={<History />} />
            <Route path="/settings" element={<Settings />} />
          </Routes>
        </main>
      </div>
    </BrowserRouter>
  );
}
